import React from "react";
import ReactDOM from "react-dom";
import { StylesProvider, jssPreset } from "@material-ui/core/styles";
import { Provider as StoreProvider } from "react-redux";
import { create } from "jss";
import rtl from "jss-rtl";
import store from "./store";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import "./assets/styles/index.css";

// Configure JSS
const jss = create({ plugins: [...jssPreset().plugins, rtl()] });

ReactDOM.render(
  <React.StrictMode>
    <StoreProvider store={store}>
      <StylesProvider jss={jss}>
        <App />
      </StylesProvider>
    </StoreProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
